import { css } from "styled-components";

// 기본 폰트 패밀리 설정
export const fontFamily = {
    base: '"Pretendard", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
    code: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace'
};

// 공통 폰트 스타일을 위한 CSS 헬퍼
export const fontStyle = {
    // 기본 폰트 스타일
    base: css`
        font-family: ${fontFamily.base};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    `,

    // 코드 폰트 스타일
    code: css`
        font-family: ${fontFamily.code};
    `
};

// 재사용 가능한 글꼴 스타일 믹스인
export const font = (weight = 400, size = "1rem", lineHeight = 1.5) => css`
    ${fontStyle.base}
    font-weight: ${weight};
    font-size: ${size};
    line-height: ${lineHeight};
`;

// 폰트 관련 Styled Components 사용 예시:
//
// 1. 폰트 패밀리만 사용하는 경우:
// const Component = styled.div`
//   font-family: ${fontFamily.base};
// `;
//
// 2. 기본 폰트 스타일(패밀리+스무딩)만 사용하는 경우:
// const Component = styled.div`
//   ${fontStyle.base}
// `;
//
// 3. 모든 폰트 속성을 함께 사용하는 경우:
// const Component = styled.div`
//   ${font(700, "1.5rem", 1.3)}
// `;
